import { reactive, readonly } from "vue";
import { ASSISTENT_API_URL } from "@/config/backend"
import axios from "axios";
import authModule from "../auth";
import reportingModule from "../reporting";
import customerModule from "../customer";
import router from "@/router";

import useAlert from "@/hooks/useAlert";
const { showAlertByKey } = useAlert();

const state = reactive({
    currentDeviceId: null,
    currentDeviceSerialId: null,
    currentDevice: null,
    availableDevices: [],
    automaticSmsConfiguration: null
});

const actions = {
    initializeDevices: async () => {
        if (state.availableDevices.length == 0) {
            const url = ASSISTENT_API_URL + "devices";
            return axios
                .get(
                    url,
                    {
                        headers: authModule.getters.getApiHeaders()
                    }
                )
                .then((response) => {
                    state.availableDevices = response.data.devices;

                    const existingDeviceId = localStorage.getItem("deviceId");
                    if (existingDeviceId) {
                        const storageDevice = actions.findDeviceByDeviceId(existingDeviceId);
                        if (storageDevice !== null) {
                            actions.setSelectedDevice(storageDevice, storageDevice.deviceId);
                            return;
                        }
                    }

                    if (state.availableDevices.length == 1) {
                        actions.setSelectedDevice(state.availableDevices[0], state.availableDevices[0].deviceId);
                    }
                })
                .catch(() => {
                    const errorMessage = new Error('UNKNOWN_ERROR');
                    throw errorMessage;
                });
        }
    },
    setSelectedDevice: (selectedDevice, serialId) => {
        const updated = serialId != state.currentDeviceSerialId;

        state.currentDeviceId = selectedDevice.id;
        state.currentDeviceSerialId = serialId;
        state.currentDevice = selectedDevice;

        localStorage.setItem("deviceId", serialId);

        if (updated) {
            reportingModule.actions.reset();
            customerModule.actions.reset();
        }

        router.push({ 'name': 'home' });
    },
    getAutomaticSmsConfiguration: async () => {
        if (state.automaticSmsConfiguration != null) {
            return state.automaticSmsConfiguration;
        }

        const url = ASSISTENT_API_URL + "device/" + state.currentDeviceSerialId + "/sms/automatic";

        return axios
            .get(url, { headers: authModule.getters.getApiHeaders() })
            .then((response) => {
                state.automaticSmsConfiguration = response.data.resultObject;
                return state.automaticSmsConfiguration;
            })
            .catch(() => {
                showAlertByKey("error.unknown");
                const errorMessage = new Error('UNKNOWN_ERROR');
                throw errorMessage;
            });
    },
    resetAutomaticSmsConfiguration: () => {
        state.automaticSmsConfiguration = null;
    },
    updateConfigData: async (key, value) => {
        state.currentDevice.deviceConfiguration[key] = value;

        const url = ASSISTENT_API_URL + "configuration/basic/" + state.currentDeviceSerialId;
        const putBody = {
            key: key,
            value: value,
        };

        return axios
            .put(url, putBody, { headers: authModule.getters.getApiHeaders() });
    },
    findDeviceByDeviceId: (deviceId) => {
        if (state.availableDevices && state.availableDevices.length > 0) {
            return state.availableDevices.find(d => d.deviceId === deviceId) || null;
        }
        return null;
    },
    reset: () => {
        state.currentDeviceId = null;
        state.currentDeviceSerialId = null;
        state.availableDevices = [];
        state.automaticSmsConfiguration = null;
        state.currentDeviceData = [];
    },
    resetState: () => {
        localStorage.removeItem("deviceId");
    },
    getAvailableDevices: () => {
        return state.availableDevices;
    }
}

const getters = {
    isDeviceSelected: () => !!state.currentDeviceId,
    getData: (key) => {
        const configArray = { ...state.currentDevice.deviceConfiguration };
        if (configArray[key] !== null) {
            return configArray[key];
        }
        return "";
    },
    isMdsDevice: () => {
        return state.currentDevice.type === "DEVICE_SELECTOR";
    },
    getCurrentDeviceData: () => state.currentDevice,
    getAvailableDevices: () => state.availableDevices,
    getCurrentDeviceId: () => state.currentDeviceId,
    getCurrentDeviceSerialId: () => state.currentDeviceSerialId,
    getCurrentDevice: () => state.currentDevice,
}

const devicesModule = {
    state: readonly(state),
    actions,
    getters
}

export default devicesModule;